export const TransferIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 12L4.5 13M21.5 12.5L19.5 13M8 17.5L8.246 16.886C8.611 15.973 8.794 15.516 9.175 15.258C9.555 15 10.047 15 11.031 15H12.969C13.953 15 14.445 15 14.825 15.258C15.205 15.516 15.389 15.973 15.755 16.886L16 17.5M2 17V19.882C2 20.261 2.24 20.607 2.622 20.776C2.869 20.886 3.105 21 3.391 21H5.109C5.395 21 5.631 20.886 5.879 20.776C6.259 20.607 6.5 20.261 6.5 19.882V18M17.5 18V19.882C17.5 20.261 17.74 20.607 18.122 20.776C18.369 20.886 18.605 21 18.891 21H20.609C20.895 21 21.131 20.886 21.379 20.776C21.759 20.607 22 20.261 22 19.882V17M20 8.5L21 8M4 8.5L3 8M4.5 9L5.588 5.735C6.028 4.415 6.248 3.755 6.772 3.378C7.296 3.001 7.992 3 9.383 3H14.617C16.008 3 16.704 3 17.227 3.378C17.752 3.755 17.972 4.415 18.412 5.735L19.5 9"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 9H19.5C20.457 10.014 22 11.425 22 13V16.47C22 17.04 21.62 17.52 21.117 17.587L18 18H6L2.883 17.587C2.38 17.522 2 17.042 2 16.47V13C2 11.425 3.543 10.014 4.5 9Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
